export enum InputIconType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    ICON = 'ICON'
}

export class InputPrefixSuffixType {
    constructor(public iconType: InputIconType, public value: string){}
}